import React from 'react';
import TwitterSection from './TwitterSection';
import WordpressSection from './WordpressSection';

const ContentFeeds = ({ data }) => {
    return (
        <div className="ContentFeeds">
            <TwitterSection accountName="cwsprings" />
            <div className="mobileSeparator" />
            <WordpressSection data={data} />
            <TwitterSection accountName="campwillowrun" />
        </div>
    );
};

export default ContentFeeds;



// WEBPACK FOOTER //
// ./src/components/ContentFeeds.js